module.exports = __webpack_public_path__ + "static/media/48390697_2309071852501326_1949408359127973888_o-thumb.6b03ba38.jpg";